import { convertSecondsToTime } from 'common/helpers/dateAndTimeHelpersV2';
import { convertToCSV } from '../js/convertTableDataToCsv';
import saveAs from 'file-saver';
import { formatDate } from 'common/helpers/v1';


export const handleClick = (data?: Record<string, unknown>[], headers?: Record<string, string>, fileName?: string, timeZone?: string): void => {
    if (!data ||data?.length === 0) return false;


    // Modify the startTimestamp format for each item
    const modifiedData = data?.map((item) => {

      const modifiedItem = { ...item}
      item?.startTimestamp && (modifiedItem.startTimestamp = `${formatDate(
          String(item?.startTimestamp),
          'long',
          timeZone
        )} - ${formatDate(String(item?.startTimestamp), 'hours-minutes-seconds', timeZone)}`)

      item?.endTimestamp && (modifiedItem.endTimestamp = `${formatDate(String(item?.endTimestamp), 'long', timeZone)} - ${formatDate(
          String(item?.endTimestamp),
          'hours-minutes-seconds',
          timeZone
      )}`)

      item?.duration && (modifiedItem.duration = convertSecondsToTime(item?.duration))

      Object.entries(item || {}).forEach(([key, value]) => {
        if (typeof value === 'object') delete modifiedItem[key as string]
      })
      
      return modifiedItem
    }  
  )

    const csvString = modifiedData && convertToCSV(modifiedData, headers);
    const csvBlob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

    saveAs(csvBlob, fileName);
    
}

export const downloadCSV = (fileName: string, data?: Record<string, unknown>[], props?: { headers?: string[], timeZone? : string, ignoreKeys?: string[], mapKeys?: Record<string, string>}) => {
  
  if (!data) return 

  let newData = [] as typeof data

  data?.forEach((item) => {
    const newItem = {...item}
    Object.entries(item).forEach(([k, v]) => {
      if (typeof v === 'object' || Array.isArray(v)) delete newItem[k]
    })
    newData.push(newItem)
  })
   
  const csvString = convertToCSV(newData, props?.headers, props);
  const csvBlob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });

  saveAs(csvBlob, fileName);
  
}
/*
export const downloadCSV = (
  data?: Record<string, unknown>[], 
  props?: { 
    headers?: Record<string, string>, 
    fileName?: string, 
    timeZone?: string,
    format?: (x?: Record<string, unknown>) => string | number | undefined,
    mapKeys?: Record<string, string>
  }): void => {

    if (!data || data?.length === 0) return

 
    data = data?.reduce((acc: Record<string, unknown>[], item) => {
      let newItem = {} as Record<string, unknown>
      Object.entries(item).forEach(([key, value]) => {
        const newKey = props?.format?.(({key, header: true})) || props?.mapKeys || key
        const newValue = props?.format?.({key, value}) || props?.mapKeys || value
        newItem = {...newItem, [newKey as string]: newValue}
      })
      acc.push(newItem)
      return acc
    }, [])

    // Extract all the unique keys from the data
    const keys = Array.from(new Set(data.flatMap((record) => Object.keys(record))))

    // Create the header row of the CSV
    const headerRow = keys.map((k) => props?.headers?.[k] || k).join(',') + '\n';

    // Create the data rows of the CSV
    const dataRows = data
      .map((record) =>
        keys.map((key) => (record[key] !== undefined ? String(record[key]) : '')).join(',')
      )
      .join('\n');

    // Combine the header row and data rows into the final CSV string
    return headerRow + dataRows;

  }
    */